module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_3_B-ce11acd6c6c1171cf59b66975af302de.gif";